import HoverCard from './hover-card'
HoverCard.install = function (Vue) {
  Vue.component(HoverCard.name, HoverCard)
}
export default HoverCard
